import axios from "axios";

// Tạo một instance của Axios
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Sử dụng URL từ biến môi trường
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor cho request: Thêm token vào tất cả các request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor cho response: Xử lý lỗi hoặc token hết hạn
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Xử lý các lỗi phổ biến như 401, 403 (token hết hạn hoặc không hợp lệ)
    if (error.response && error.response.status === 401) {
      // Xử lý việc token hết hạn (có thể logout hoặc refresh token tại đây)
      console.error("Token hết hạn hoặc không hợp lệ. Vui lòng đăng nhập lại.");
      localStorage.removeItem("accessToken");
      window.location.href = "/login"; // Chuyển hướng về trang login
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
